export default function () {
    const widgetName = 'multiScheduleFeature';
    const widgetOpts = multiScheduleFeatureOpts;



    $(`#${widgetName}`).append('<div class="multiFeatureContent"></div>');
    $(`#${widgetName}`).MultiScheduleFeature({
        scriptPath: widgetOpts.scriptPath
        , currentWidgetModuleItemID: widgetOpts.WidgetModuleDataItemID
        , detectIpad: IPADDETECTED
        // options
        , allEventsLink: false
        , allEventsLinkText: 'ALL EVENTS'
        , hasImages: true
        , imageBackground: false
        , lazyLoadImages: true
        , buyNowButton: { visible: false, text: 'BUY NOW' }
        , moreButton: { visible: true, text: 'MORE' }
        , maxItemsVisible: 8
        , isResponsive: false
        , hasDescription: false
        , textContainer: false
        , link: '' //options are 'all', 'text', 'image', 'imageAndText', or ''
        , attributeOrder: {
            1: 'date',
            2: 'image',
            3: 'title',
            4: 'description',
            5: 'buttons',
        }
        , multiFeatureLoaded: function (data) {

            let eventsCount = data.length;

            $('#multiScheduleFeature .featureItem').each(function (i) {
                let widgetData = data;
                let eventName = widgetData[i].Name;
                let eventUrl = widgetData[i].URL;
                let eventImg = widgetData[i].ImageURL == "" ? `${FULLCLIENTTHEMEPATH}images/no_image_available.jpg` : widgetData[i].ImageURL;
                let eventDateRaw = widgetData[i].Date;

                $(this).find('.featureItemDate').remove();
                $(this).find('.featureItemImage').remove();
                $(this).find('.featureItemTitle').remove();
                $(this).find('.featureItemDescription').remove();
                $(this).find('.button-container').remove();
                $(this).find('.all-events-btn').remove();

                $(this).append(`
                    <div class="img-container">
                        <div class="overlay"></div>
                        <div class="btn-container">
                            <a href="${eventUrl}" class="button">More</a>
                        </div>
                        <img class="featureItemImage" src="${eventImg}" alt="${eventName}">
                        <div class="event-date">
                        <span class="month">${eventDateRaw.slice(0, 3)}</span>
                        <span class="day">${eventDateRaw.slice(4, 7).replace(',', '')}</span>
                        </div>
                    </div>
                <div class="event-content">
                    <span>${eventName}</span>
                </div>
                          `)

                if (eventUrl == "") {
                    $(this).removeAttr('href');
                    $(this).addClass('void');
                    $(this).find('.button').remove();
                    $(this).find('.overlay').remove();
                }
            });

            if (eventsCount == 0) {
                $('.tier-2-container .inner-container').remove();
            }

        }
    });
};